import { MessageBox, Message } from 'element-ui'
import cfg from '../../config'
import update from '../../utils/update'
import emitter from '@utils/eventbus'
import DBUtil from '@utils/DBUtil'
import store from '../store'
import NetworkMonitor from '@utils/NetworkMonitor'
import logClickEvent from '@utils/logClickEvent'
import { getOsType } from '@utils/utils'
import { getAppLatest } from 'api/electron'

class Ipc {
  constructor(app) {
    this.app = app
    this.$store = app.$store
    this.log = console
    this.ipc = window.ipcRenderer
    this.remote = window.remote
    this.os = require('os')
    this.isInit = false
    this.cfg = cfg
    this.appVersion = cfg.VUE_APP_VERSION
    this.beta_version = cfg.VUE_APP_PRE
    this.downloaded = false
  }

  init() {
    this.initIpc()
    this.isInit = true
  }

  initIpc() {
    // watch main process send message
    this.ipc.on('main-process-messages', async (event, arg) => {
      const { type, data } = arg
      if (type == 'load-account') {
        this.$store.commit('setSelectedSource', 'account')
      }
      if (type == 'sync') {
        emitter.emit('sync-memo')
      }

      if (type == 'reload') {
        this.$store.getters.isProduction ? (window.location.href = 'flomo://./index.html') : location.reload()
      }

      if (type === 'new-memo-created') {
        emitter.emit('new-memo-created', data)
      }

      if (type === 'cacheImage') {
        window.$MemoImageStore
          .setItem(data.shortUrl, data)
          .then((value) => {
            // window.$global.localImages[data.shortUrl] = data
            window.$global.imageCache.set(data.shortUrl, data)
          })
          .catch(function (err) {
            console.log(err)
          })
      }

      if (type == 'main-window-show') {
        // 检查网络状态
        NetworkMonitor.checkNetworkStatus()
        emitter.emit('sync-memo')
        if (this.app.$children[0].$refs.memo_list) {
          this.app.$children[0].$refs.memo_list.$refs.fl_editor.focus()
        }
      }

      if (type == 'clear-cache-success') {
        Message({
          message: this.app.$t('message.clearCacheSuccess'),
          type: 'success',
        })
      }
      if (type == 'clear') {
        MessageBox.confirm('清理缓存后需要重新登录，确定要清理吗？', this.app.$t('app.update.tip'), {
          confirmButtonText: '确定',
          cancelButtonText: this.app.$t('app.update.cancel'),
          type: 'warning',
        })
          .then(() => {
            localStorage.clear()
            setTimeout(() => {
              this.$store.getters.isProduction ? (window.location.href = 'flomo://./index.html') : location.reload()
            }, 300)
          })
          .catch(() => {})
      }

      if (type == 'logout') {
        const update_memo_count = await DBUtil.getTotalActionCount()
        if (update_memo_count) {
          MessageBox.confirm(
            this.app.$t('components.logout.tips.content'),
            this.app.$t('components.logout.tips.title'),
            {
              confirmButtonText: this.app.$t('components.logout.tips.confirm'),
              cancelButtonText: this.app.$t('components.logout.tips.cancel'),
              confirmButtonClass: 'delete-confirm-button',
            },
          )
            .then(() => {
              store.dispatch('logout')
            })
            .catch(() => {})
        } else {
          store.dispatch('logout')
        }
      }

      if (type == 'downloaded') {
        if (this.downloaded) {
          return
        }
        this.downloaded = true
        this.$store.dispatch('appUpdate/setDownloaded', true)
      }

      if (type === 'update-error') {
        if (getOsType() == 'win') {
          logClickEvent('增量更新', '更新失败')
        }
      }

      if (type == 'openMemo') {
        emitter.emit('open-memo', data)
      }
    })

    this.initBaiduTongji()

    this.send(
      'appLanguageChange',
      this.$store.state.me.language ? this.$store.state.me.language.toLowerCase().slice(0, 2) : 'zh',
    )

    this.send('appDarkModeToggle', this.$store.state.theme)

    this.send('appUser', this.$store.state.me)

    this.send('hotkey-change', this.$store.state.hotkeys)
    this.checkUpdate()

    // 同步环境变量
    this.send('appEnvConfig', cfg)
  }

  initBaiduTongji() {
    let hmName = 'hm.js'
    const hm = document.createElement('script')
    if (this.$store.getters.isElectron && this.$store.getters.isProduction) {
      hm.src = `flomo://./${hmName}`
    } else {
      hm.src = `./${hmName}`
    }

    hm.name = 'hm'

    if (!document.querySelector('script[name="hm"]')) {
      const s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
    }
  }

  //  send message
  send(type, data) {
    this.ipc.send(type, data)
  }

  destroyed() {
    this.ipc.removeAllListeners('main-process-messages')
  }

  async checkUpdate() {
    if (window.location.href.indexOf('tray') == -1) {
      const {
        data: { code, data },
      } = await getAppLatest()

      if (code == 0) {
        const { version } = data
        update(this.appVersion, version).then((res) => {
          const { code, type } = res
          if (code == 1) {
            if (getOsType() == 'win') {
              logClickEvent('增量更新', '升级提示')
            }
            this.send('appUpdate', {
              needUpdate: code > 0,
              show: false,
              updateType: type,
              ...data,
            })
          }
        })
      }
    }
  }
}

export default Ipc
